import { useContext } from "react";
import LanguageContext from "../context/language-context";

function useLanguageContext(){
    return useContext(LanguageContext)
}

export {useLanguageContext};